import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './exploremore.css';

import bookIcon from '../../assets/books-stack-of-three.png';
import penIcon from '../../assets/pen.png';
import codeIcon from '../../assets/code.png';
import toolsIcon from '../../assets/tools.png';
import { useNavigate } from 'react-router-dom';

function ExploreCard({ icon, title, desc, link, delay }) {
  const navigate = useNavigate();

  return (
    <div
      className="explore-card"
      data-aos="fade-up"
      data-aos-delay={delay}
      tabIndex={0}
      role="link"
      onClick={() => navigate(link)}
      onKeyDown={(e) => e.key === 'Enter' && navigate(link)}
    >
      <img src={icon} alt="" className="explore-icon" />

      <h3>{title}</h3>

      <div className="explore-content">
        <p>{desc}</p>
        <span className="explore-link">
          Get started <span className="explore-arrow">→</span>
        </span>
      </div>
    </div>
  );
}

function ExploreMore() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="explore-more-section" id="exploremore">
      <h2 className="explore-heading">
        Explore{' '}
        <span className="explore-circled">
          More
          <svg className="explore-circle-svg" viewBox="0 0 200 70" aria-hidden="true">
            <path d="M8 40 C 10 10, 60 2, 100 4 C 150 6, 195 14, 192 38 C 189 60, 130 68, 90 66 C 45 64, 5 55, 8 40 Z" />
          </svg>
        </span>
      </h2>

      <div className="explore-grid">
        <div className="explore-column">
          <ExploreCard
            icon={bookIcon}
            title="Loubna's Library"
            desc="I enjoy reading and like to keep notes and takeouts. Here's my take on some of the books I've read."
            link="/library"
            delay="0"
          />
          <ExploreCard
            icon={toolsIcon}
            title="My Toolkit"
            desc="A peek into the gadgets, apps, and tools I use daily for coding, designing, and staying productive."
            link="/my-toolkit"
            delay="150"
          />
        </div>

        <div className="explore-column">
          <ExploreCard
            icon={codeIcon}
            title="Tech Projects"
            desc="These are side projects I build for fun, learning, and personal growth."
            link="/tech-projects"
            delay="75"
          />
          <ExploreCard
            icon={penIcon}
            title="Learn Journaling"
            desc="See how I mix storytelling with design to bring ideas to life."
            link="/journaling"
            delay="225"
          />
        </div>
      </div>
    </section>
  );
}

export default ExploreMore;